import React from "react";

const PersonPlaceholder = () => (
  <div className="PersonCard PersonCard__Placeholder col-xs-12 col-sm-6 col-md-4">
    <div className="people-list-item">
      <div className="col-xs-12 header">
        <div className="profile-photo" />
      </div>
      <div className="col-xs-12">
        <div>
          <p className="name" />
          <hr />
          <p />

          <p />
          <span className="interest" />
          <span className="interest" />
          <span className="interest" />
        </div>
      </div>
    </div>
  </div>
);

export default PersonPlaceholder;
